import { createFileRoute } from '@tanstack/react-router';

import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';
import Loading from '@/_pages/agreements/deliverables/loading';

export const Route = createFileRoute('/_private/agreements/_template/$id/deliverables')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: false,
    pageTitle: 'Deliverables',
    tabKey: 'agreement/deliverables',
    isFullWidth: true,
  },
  pendingComponent: Loading,
});
